import { render, staticRenderFns } from "./QRPage.vue?vue&type=template&id=6ed6e4a9&scoped=true"
import script from "./QRPage.vue?vue&type=script&lang=js"
export * from "./QRPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed6e4a9",
  null
  
)

export default component.exports